import { Box, Typography, Link } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        color: "black",
        padding: { xs: "2rem", sm: "3rem", md: "5rem" }, // Responsive padding
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        textAlign: "center",
      }}
    >
      {/* Left Side - Location */}
      <Typography
        variant="h6"
        sx={{
          flex: 1,
          textAlign: { xs: "center", sm: "left" }, // Center on mobile, left on larger screens
          fontSize: { xs: "1rem", md: "1.25rem" },
          paddingLeft: { xs: "0", sm: "2rem", md: "5rem" }, // No padding on mobile, increasing with screen size
          marginBottom: { xs: "1rem", sm: "0" }, // Add space below on mobile
        }}
      >
        Greater Seattle Area
      </Typography>

      {/* Right Side - Instagram Link */}
      <Box
        sx={{
          flex: 1,
          textAlign: { xs: "center", sm: "right" } // Center on mobile, right on larger screens
        }}
      >
        <Link
          href="https://www.instagram.com/nicolehahndesigns/"
          target="_blank"
          rel="noopener"
          sx={{
            color: "black",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: { xs: "center", sm: "flex-end" }, // Center on mobile, flex-end on larger screens
            fontSize: { xs: "1rem", md: "1.25rem" },
          }}
        >
          <InstagramIcon
            sx={{
              fontSize: { xs: 32, md: 40 }, // Smaller icon on mobile
              paddingRight: { xs: "0", sm: "4rem", md: "8rem" } // No padding on mobile, increasing with screen size
            }}
          />
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;